export default [
    {
        text: 'Status',
        value: null
    },
    {
        text: 'Ready to ship',
        value: 'ready'
    },
    {
        text: 'Shipped',
        value: 'shipped'
    },
    {
        text: 'In transit',
        value: 'transit'
    },
    {
        text: 'Delivered',
        value: 'delivered'
    },
    {
        text: 'Receiving',
        value: 'receiving'
    },
    {
        text: 'Processed',
        value: 'processed'
    },
    {
        text: 'Shipment‘s problem',
        value: 'problem'
    },
    {
        text: 'Canceled',
        value: 'canceled'
    },
    {
        text: 'Returned',
        value: 'returned'
    },
    {
        text: 'Closed',
        value: 'closed'
    }
]



// WEBPACK FOOTER //
// ./src/assets/js/status/replenishment/shipment.js